module.exports = __webpack_public_path__ + "static/img/noLiveCover.52f8ed40.jpg";